import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { provideNgxMask } from 'ngx-mask';

import { ControlWrapperComponent } from '../control-wrapper/control-wrapper.component';
import { ControlHasRequiredPipe } from '../pipes/control-has-required.pipe';
import { OfficeToolsValidators } from '../../validators';
import { MASK_CONFIG } from './constants/mask.constants';
import { MaskedInputDirective } from './directives/masked-input-base.directive';
import { InputType, InputTypeEnum } from './models/input-type.models';
import { InputPercentComponent } from './input-percent/input-percent.component';
import { InputCustomComponent } from './input-custom/input-custom.component';
import { DateTimeHelper } from '../../../../shared/helpers/date-time.helper';
import { InputMaskHelper } from './helpers/input-mask.helper';

@Component({
    selector: 'app-input',
    templateUrl: 'input.component.html',
    styleUrls: ['input.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        ControlWrapperComponent,
        ReactiveFormsModule,
        ControlHasRequiredPipe,
        CommonModule,
        InputPercentComponent,
        InputCustomComponent,
    ],
    providers: [provideNgxMask(MASK_CONFIG)]
})
export class InputComponent extends MaskedInputDirective implements OnInit {
  @Input() override type: InputType = 'text';

  readonly InputTypeEnum = InputTypeEnum;

  ngOnInit(): void {
    super.ngOnInit();
    this.addValidatorsByType();
    this.formatValueByType();
  }

  private addValidatorsByType(): void {
    switch (this.type) {
      case InputTypeEnum.number:
        this.control.addValidators(OfficeToolsValidators.numericRange(this.officeField));
        break;
      case InputTypeEnum.percent:
        this.control.addValidators(OfficeToolsValidators.percent());
        break;
      default:
        break;
    }
  }

  private formatValueByType(): void {
    switch (this.type) {
      case InputTypeEnum.time:
        this.control.setValue(DateTimeHelper.getTimeFormatted(this.control.value), { emitEvent: true, onlySelf: true });
        break;
      case InputTypeEnum.percent:
        break;
      default:
        if (
          this.officeField.InputMask &&
          (this.officeField.InputMaskConfig?.isMultipartMask || this.officeField.InputMaskConfig?.justification)
        ) {
          // NOTE: Formatting for multipart mask is required because the data returned from the database is not trimmed.
          // This has been implemented for lookups and the default value of the field.
          this.control.setValue(InputMaskHelper.formatMultiPartIfApplicable(this.control.value, this.officeField), {
            emitEvent: false,
            onlySelf: true,
          });
        }
        break;
    }
  }
}
